import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const styleForAddToCartModal = {
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: 400,
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    color: 'black',
    lineHeight: 'normal'
}
